<div
	class="modal-roles w-[475px] duration-500 h-full flex flex-col justify-between"
	[ngClass]="{ 'w-[950px]': showViewRoles }"
>
	<!-- Header -->
	<div
		class="header h-[50px] flex justify-between px-[16px] items-center border-b border-b-neutral-color-i"
	>
		<div class="title font-lato text-base text-complementary-color-b font-normal">
			<span> {{ title | titlecase }} </span>
		</div>
		<div class="close flex justify-between gap-3 relative">
			<button
				(click)="showViewRoles = !showViewRoles"
				class="flex items-center justify-center border border-[#767676] rounded-[5px] px-0.5 w-[30px] h-[30px] relative rotate-90"
			>
				<mat-icon
					class="text-[#767676] icon-panel"
					[ngClass]="{ 'icon-panel-active': showViewRoles }"
					>splitscreen</mat-icon
				>
			</button>
			<button class="close flex justify-center items-center" (click)="onNoClick()">
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>
	<!-- Content -->
	<div
		class="content flex h-[calc(100%-50px-54px)] overflow-auto border-b border-b-neutral-color-i"
	>
		<!-- Main content -->
		<div class="main-content w-full p-[16px]">
			<form action="" [formGroup]="formRole">
				<div>
					<label class="text-sm" for="Name">{{ translateModal.name }}</label>
					<input
						class="name input-app"
						[placeholder]="translateModal.name"
						type="text"
						formControlName="name"
					/>
				</div>
				<div class="flex flex-col mt-[14px]">
					<label class="mb-1 text-sm" for="">{{ translateModal.description }}</label>
					<textarea
						class="input-app text-area !h-[60px] !pt-1.5"
						[placeholder]="translateModal.description"
						formControlName="description"
					></textarea>
				</div>
			</form>
			<!-- Resources -->
			<div class="mt-3">
				<span class="font-lato text-sm font-normal"> {{ translateModal.resources }} </span>
				<div
					*ngIf="!loadingResources && listResources.length === 0"
					class="resources flex flex-col items-center justify-center h-[calc(100vh-579px)] min-h-[132px] mt-[14px] w-full rounded-md px-4 bg-[#F8F8F8] overflow-y-auto overflow-x-hidden"
				>
					<img src="../../../../assets/icon/notFile.svg" class="w-[60px]" alt="" />
					<span class="font-lato text-xs text-[#282828] w-[250px] text-center">
						{{ translateModal.textNotResources }}
					</span>
				</div>
				<div
					*ngIf="loadingResources"
					class="resources h-[calc(100vh-579px)] min-h-[132px] mt-[14px] w-full rounded-md px-4 bg-[#F8F8F8] overflow-y-auto overflow-x-hidden"
				>
					<app-loading-spinner></app-loading-spinner>
				</div>
				<div
					class="resources h-[calc(100vh-579px)] min-h-[132px] mt-[14px] w-full rounded-md px-4 bg-[#F8F8F8] overflow-y-auto overflow-x-hidden"
					infiniteScroll
					[infiniteScrollDistance]="2"
					[infiniteScrollThrottle]="50"
					[infiniteScrollContainer]="selector"
					[fromRoot]="true"
					(scrolled)="onScroll()"
					*ngIf="!loadingResources && listResources.length !== 0"
				>
					<div
						class="add-resource flex justify-between items-center h-[48px] border-b border-neutral-color-d pb-3 pt-2"
						[ngClass]="{ 'bg-[#fbfbfb]': i % 2 != 0 }"
						*ngFor="let resource of listResources || []; let i = index"
					>
						<div class="content-resource">
							<div class="title-resource h-[14px]">
								<span class="text-resources"> {{ resource.name }}</span>
							</div>
							<div class="description-resource">
								<span class="text-resources"> {{ resource.path }} </span>
							</div>
						</div>
						<div class="content-resource">
							<div class="title-resource h-[14px]">
								<span class="text-resources"> {{ resource.action }} </span>
							</div>
							<div class="description-resource">
								<span class="text-resources font-normal"> {{ resource.module.name }} </span>
							</div>
						</div>
						<div class="delete flex items-center justify-center">
							<mat-icon
								class="cursor-pointer text-lg add text-primary-color"
								(click)="deleteResource(resource)"
								>delete</mat-icon
							>
						</div>
					</div>
				</div>
				<div
					class="result flex justify-between items-center h-[38px] bg-[#F5F5F5] px-3 rounded-b-md"
				>
					<span class="text-total"> Total </span>
					<span class="text-total">
						{{ listResources.length }}
					</span>
				</div>
			</div>
		</div>
		<!-- Two content -->
		<div
			class="option-content w-full overflow-x-hidden border-l border-l-neutral-color-i p-[16px]"
			[ngClass]="{ ' p-0 w-0': !showViewRoles }"
		>
			<div class="flex flex-col">
				<label class="mb-1 text-sm" for=""> {{ translateModal.titleFilter }} </label>
				<div class="flex gap-4">
					<div class="client flex flex-col min-w-[calc(180px)]">
						<p-dropdown
							[options]="clients"
							[(ngModel)]="client"
							[disabled]="data.type === 'update'"
							[placeholder]="translateModal.client"
							[ngModelOptions]="{ standalone: true }"
							optionLabel="name"
							[autoDisplayFirst]="false"
							(onChange)="selectClient($event)"
						>
						</p-dropdown>
					</div>
					<div class="client flex flex-col min-w-[calc(180px)]">
						<p-dropdown
							[options]="client?.module || []"
							[(ngModel)]="moduleSelect"
							[placeholder]="(translateModal && translateModal.module) || ''"
							[ngModelOptions]="{ standalone: true }"
							optionLabel="custom_name_module"
							(onChange)="selectedModule()"
							[autoDisplayFirst]="false"
						>
						</p-dropdown>
					</div>
				</div>
			</div>
			<div class="mt-[14px]">
				<label class="mb-1 text-sm" for="Search"> {{ translateModal.search }} </label>
				<div class="relative">
					<input
						type="text"
						class="search w-full h-10 rounded-xl text-base font-lato input-app !pl-[35px]"
						[placeholder]="translateModal.search"
						[(ngModel)]="searchResource"
						(ngModelChange)="search($event)"
						[ngModelOptions]="{ standalone: true }"
					/>
					<mat-icon class="absolute top-[6px] left-2.5 text-neutral-color-f">search</mat-icon>
				</div>
			</div>
			<div
				class="resources resourceSelector h-[calc(100vh-517px)] min-h-[162px] mt-[14px] w-full rounded-md px-4 bg-[#F8F8F8] overflow-y-auto overflow-x-hidden"
				infiniteScroll
				[infiniteScrollThrottle]="50"
				[infiniteScrollContainer]="selector"
				[fromRoot]="true"
				(scrolled)="onScroll()"
				*ngIf="!loadingResources"
			>
				<div
					class="add-resource flex justify-between items-center h-[48px] border-b border-neutral-color-d pb-3 pt-2"
					[ngClass]="{ 'bg-[#fbfbfb]': i % 2 != 0 }"
					*ngFor="let resource of resources || []; let i = index"
				>
					<div class="content-resource">
						<div class="title-resource h-[14px]">
							<span class="text-resources"> {{ resource.name }}</span>
						</div>
						<div class="description-resource">
							<span class="text-resources"> {{ resource.path }} </span>
						</div>
					</div>
					<div class="content-resource">
						<div class="title-resource h-[14px]">
							<span class="text-resources"> {{ resource.action }} </span>
						</div>
						<div class="description-resource">
							<span class="text-resources font-normal"> {{ resource.module.name }}</span>
						</div>
					</div>
					<div class="add flex items-center justify-center">
						<mat-icon
							class="cursor-pointer text-lg add text-primary-color"
							(click)="addResource(resource)"
							>add</mat-icon
						>
					</div>
				</div>
				
			</div>
			<div
				*ngIf="loadingResources"
				class="resources h-[calc(100vh-517px)] min-h-[162px] mt-[14px] w-full rounded-md px-4 bg-[#F8F8F8] overflow-y-auto overflow-x-hidden"
			>
				<app-loading-spinner></app-loading-spinner>
			</div>
		</div>
	</div>
	<!-- Footer -->
	<div class="footer-modal">
		<button (click)="onNoClick()" class="mg-button secundaryButton mr-3">
			{{ translateModal.buttonCancel }}
		</button>
		<button
			(click)="save()"
			[disabled]="formRole.invalid || validateClient(this.client) || listResources.length === 0"
			class="mg-button primaryButton"
		>
			{{ translateModal.buttonSave }}
		</button>
	</div>
</div>
